import * as Sentry from '@sentry/vue'
import axios from 'axios'

/**
 * Statuses the UI already answers with its own message. Reporting them would bury real defects
 * under login typos, oversized uploads and expired sessions.
 */
const handledStatuses = new Set([401, 403, 413, 419, 422, 429])

function isHandledByTheUi(error: unknown): boolean {
  if (!axios.isAxiosError(error)) {
    return false
  }

  const status = error.response?.status

  return status !== undefined && handledStatuses.has(status)
}

export function reportError(message: string, error: unknown): void {
  console.error(message, error)

  if (isHandledByTheUi(error)) {
    return
  }

  Sentry.captureException(error, { extra: { context: message } })
}

export function reportWarning(message: string, context: Record<string, unknown>): void {
  console.warn(message, context)

  Sentry.captureMessage(message, { level: 'warning', extra: context })
}
